import React, { Component } from 'react'
import './ModifyHours.css'
import { AnimatePresence, motion } from 'framer-motion'
import { backdropTransition, popupTransition, transitionDuration } from '../../../../../../../Util/PageTransitions'
import EditMinutes from './Components/EditMinutes/EditMinutes'

export default class ModifyHours extends Component {

    constructor() {
        super()
        this.state = {
            times: ['12 AM', '1 AM', '2 AM', '3 AM', '4 AM', '5 AM', '6 AM', '7 AM', '8 AM', '9 AM', '10 AM', '11 AM', '12 PM', '1 PM', '2 PM', '3 PM', '4 PM', '5 PM', '6 PM', '7 PM', '8 PM', '9 PM', '10 PM', '11 PM'],
            timeSelected: 0,
            modeSelected: 0,
            currentRowHovered: -1,
            currentColumnHovered: -1,
            editMinutes: false,
            columnSelected: 0,
            rowSelected: 0,
            hoursOfOperation: [
                [
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ]
                ], [
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ],
                    [
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                        false,
                    ]
                ]
            ]
        }
    }

    componentDidMount() {
        this.setState({ hoursOfOperation: this.props.hoursOfOperation })
    }

    updateOperationHoursHandler = (column, row, event) => {
        let hoursOfOperation = this.state.hoursOfOperation
        hoursOfOperation[this.state.modeSelected][column][row] = !hoursOfOperation[this.state.modeSelected][column][row]
        this.setState({ hoursOfOperation })
    }

    updateRowHoveredHandler = (event, index, column) => {
        if (event.buttons === 1) {
            this.updateOperationHoursHandler(column - 1, index)
        }
        this.setState({ currentRowHovered: index, currentColumnHovered: column })
    }

    timer = 0;
    delay = 350;
    prevent = false;

    handleClick(column, row, event) {
        this.timer = setTimeout(() => {
            if (!this.prevent) {
                this.updateOperationHoursHandler(column, row, event)
            }
            this.prevent = false;
        }, this.delay);
    }

    handleDoubleClick(column, row) {
        clearTimeout(this.timer);
        this.prevent = true;
        this.setState({ editMinutes: true, columnSelected: column, rowSelected: row })
    }

    getHoursCellText = (cellData, row) => {
        let hours = row === 0 ? 12 : row === 12 ? 12 : row < 12 ? row : row - 12

        if (cellData[0]) {
            if (cellData[1]) {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return ''
                    } else {
                        return `${hours}:00-${hours}:45`
                    }
                } else {
                    if (cellData[3]) {
                        return `${hours}:00-${hours}:30/${hours}:45-${hours + 1}:00`
                    } else {
                        return `${hours}:00-${hours}:30`
                    }
                }
            } else {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return `${hours}:00-${hours}:15/${hours}:30-${hours + 1}:00`
                    } else {
                        return `${hours}:00-${hours}:15/${hours}:30-${hours}:45`
                    }
                } else {
                    if (cellData[3]) {
                        return `${hours}:00-${hours}:15/${hours}:45-${hours + 1}:00`
                    } else {
                        return `${hours}:00-${hours}:15`
                    }
                }
            }
        } else {
            if (cellData[1]) {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return `${hours}:15-${hours + 1}:00`
                    } else {
                        return `${hours}:15-${hours}:45`
                    }
                } else {
                    if (cellData[3]) {
                        return `${hours}:15-${hours}:30/${hours}:45-${hours + 1}:00`
                    } else {
                        return `${hours}:15-${hours}:30`
                    }
                }
            } else {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return `${hours}:30-${hours + 1}:00`
                    } else {
                        return `${hours}:30-${hours}:45`
                    }
                } else {
                    if (cellData[3]) {
                        return `${hours}:45-${hours + 1}:00`
                    }
                }
            }
        }
    }

    getDailyContainers = (props) => {
        let rowHolder = []
        if (props.column === 0) {
            for (let i = 0; i < 24; ++i) {
                rowHolder.push(
                    <div className={`modifyHoursCellContainer ${this.state.currentRowHovered === i ? 'rowHovered' : ''}`} key={i}>
                        <p className='modifyHoursCellText'>{this.state.times[(i + this.state.timeSelected) % 24]}</p>
                    </div>
                )
            }
            let column = (
                <div className='modifyHoursDayContainer'>
                    <div className='modifyHoursCellContainer'></div>
                    {rowHolder}
                </div>
            )
            return column
        } else {
            for (let i = 0; i < 24; ++i) {
                rowHolder.push(
                    <div className={`modifyHoursCellContainer modifyHoursClickableCell ${props.hoursOfOperation[i] ? 'modifyHoursSelectedCell' : ''}`}
                        onMouseDown={(event) => this.handleClick(props.column - 1, i, event)}
                        onDoubleClick={(event) => this.handleDoubleClick(props.column - 1, i)}
                        key={i}
                        onMouseEnter={(e) => this.updateRowHoveredHandler(e, i, props.column)}
                    >
                        {typeof props.hoursOfOperation[i] !== 'boolean' && <p className='modifyHoursCellText' style={{ color: 'white' }}>{this.getHoursCellText(props.hoursOfOperation[i], i)}</p>}
                    </div>
                )
            }
            let column = (
                <div className='modifyHoursDayContainer'>
                    <div className={`modifyHoursCellContainer ${this.state.currentColumnHovered === props.column ? 'rowHovered' : ''}`}>
                        <p className='modifyHoursCellText'>{props.day}</p>
                    </div>
                    {rowHolder}
                </div>
            )
            return column
        }
    }

    week = {
        sunday: ['11:30-11:45', '12:00-21:00'],
        monday: ['11:30-11:45', '12:00-21:00'],
        tuesday: ['11:30-11:45', '12:00-21:00'],
        wednesday: ['11:30-11:45', '12:00-21:00'],
        thursday: ['11:30-11:45', '12:00-21:00'],
        friday: ['11:30-11:45', '12:00-21:00'],
        saturday: ['11:30-11:45', '12:00-21:00'],
    }

    getFormattedTimeHandler = (cellData, hours) => {
        if (cellData[0]) {
            if (cellData[1]) {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return []
                    } else {
                        return [[hours, hours + 0.75]]
                    }
                } else {
                    if (cellData[3]) {
                        return [[hours, hours + 0.5], [hours + 0.75, hours + 1]]
                    } else {
                        return [[hours, hours + 0.5]]
                    }
                }
            } else {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return [[hours, hours + 0.25], [hours + 0.5, hours + 1]]
                    } else {
                        return [[hours, hours + 0.25], [hours + 0.5, hours + 0.75]]
                    }
                } else {
                    if (cellData[3]) {
                        return [[hours, hours + 0.25], [hours + 0.75, hours + 1]]
                    } else {
                        return [[hours, hours + 0.25]]
                    }
                }
            }
        } else {
            if (cellData[1]) {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return [[hours + 0.25, hours + 1]]
                    } else {
                        return [[hours + 0.25, hours + 0.75]]
                    }
                } else {
                    if (cellData[3]) {
                        return [[hours + 0.25, hours + 0.5], [hours + 0.75, hours + 1]]
                    } else {
                        return [[hours + 0.25, hours + 0.5]]
                    }
                }
            } else {
                if (cellData[2]) {
                    if (cellData[3]) {
                        return [[hours + 0.5, hours + 1]]
                    } else {
                        return [[hours + 0.5, hours + 0.75]]
                    }
                } else {
                    if (cellData[3]) {
                        return [[hours + 0.75, hours + 1]]
                    }
                }
            }
        }
    }

    getHoursRange = (numberOfHours, startingHour) => {
        return [startingHour, startingHour + numberOfHours]
    }

    saveChangesHandler = () => {
        let weekdays = [[[], [], [], [], [], [], []], [[], [], [], [], [], [], []]]
        let counting = 0
        let countingStart = 0

        for (let hoursType = 0; hoursType < 2; ++hoursType) {
            for (let dayOfWeek = 0; dayOfWeek < 7; ++dayOfWeek) {
                for (let hourOfDay = 0; hourOfDay < 24; ++hourOfDay) {
                    if (typeof this.state.hoursOfOperation[hoursType][dayOfWeek][hourOfDay] !== 'boolean') {
                        if (counting) {
                            weekdays[hoursType][dayOfWeek].push(this.getHoursRange(counting, countingStart))
                            weekdays[hoursType][dayOfWeek].push(...this.getFormattedTimeHandler(this.state.hoursOfOperation[hoursType][dayOfWeek][hourOfDay], hourOfDay))
                            counting = 0
                            countingStart = 0
                        } else {
                            weekdays[hoursType][dayOfWeek].push(...this.getFormattedTimeHandler(this.state.hoursOfOperation[hoursType][dayOfWeek][hourOfDay], hourOfDay))
                            counting = 0
                            countingStart = 0
                        }
                    } else if (this.state.hoursOfOperation[hoursType][dayOfWeek][hourOfDay]) {
                        if (countingStart === 0) {
                            countingStart = hourOfDay
                        }
                        ++counting
                    } else {
                        if (counting) {
                            weekdays[hoursType][dayOfWeek].push(this.getHoursRange(counting, countingStart))
                            counting = 0
                            countingStart = 0
                        }
                    }
                }
            }
        }
    }

    saveMinutesHandler = (minutes) => {
        let { hoursOfOperation } = this.state
        if (minutes[0] && minutes[1] && minutes[2] && minutes[3]) {
            hoursOfOperation[this.state.modeSelected][this.state.columnSelected][this.state.rowSelected] = true
        } else if (!minutes[0] && !minutes[1] && !minutes[2] && !minutes[3]) {
            hoursOfOperation[this.state.modeSelected][this.state.columnSelected][this.state.rowSelected] = false
        } else {
            hoursOfOperation[this.state.modeSelected][this.state.columnSelected][this.state.rowSelected] = minutes
        }
        this.setState({ hoursOfOperation, editMinutes: false })
    }

    render() {
        return (
            <motion.div className='modifyHoursPageContainer' initial={backdropTransition.initial} animate={backdropTransition.in} exit={backdropTransition.out} transition={{ duration: transitionDuration }}>
                <AnimatePresence>
                    {this.state.editMinutes &&
                        <EditMinutes currentTime={this.state.hoursOfOperation[this.state.modeSelected][this.state.columnSelected][this.state.rowSelected]} saveMinutesHandler={this.saveMinutesHandler} columnSelected={this.state.columnSelected} rowSelected={this.state.rowSelected} times={this.state.times} closeContainer={() => this.setState({ editMinutes: false })} />
                    }
                </AnimatePresence>
                <div className='modifyHoursBackdrop' onMouseDown={this.props.displayModifyHours} />
                <motion.div className='modifyHoursContainer' initial={popupTransition.initial} animate={popupTransition.in} exit={popupTransition.out} transition={{ duration: transitionDuration }}>
                    {/* <ModuleHeader header={'Adjust Hours Of Operation'} closeButton={() => null} /> */}
                    <div className='modifyHoursHeaderContainer'>
                        <h1 className='modifyHoursHeaderText'>Adjust Hours</h1>
                        <button className='modifyHoursHeaderCloseButton' onMouseDown={this.props.displayModifyHours}>&#10005;</button>
                    </div>
                    <div className='modifyHoursBodyContainer'>
                        <div className='modifyHoursPlatformSelectionContainer'>
                            <button className={`modifyHoursPlatformSelectionButton ${this.state.modeSelected === 0 ? 'primaryButton' : 'secondaryButton'}`} onMouseDown={() => this.setState({ modeSelected: 0 })}>Delivery</button>
                            <button className={`modifyHoursPlatformSelectionButton ${this.state.modeSelected === 1 ? 'primaryButton' : 'secondaryButton'}`} onMouseDown={() => this.setState({ modeSelected: 1 })}>Pickup</button>
                        </div>
                        <div className='modifyHoursSelectionContainer'>
                            <this.getDailyContainers column={0} />
                            <this.getDailyContainers column={1} day={'Sunday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][0]} />
                            <this.getDailyContainers column={2} day={'Monday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][1]} />
                            <this.getDailyContainers column={3} day={'Tuesday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][2]} />
                            <this.getDailyContainers column={4} day={'Wednesday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][3]} />
                            <this.getDailyContainers column={5} day={'Thursday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][4]} />
                            <this.getDailyContainers column={6} day={'Friday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][5]} />
                            <this.getDailyContainers column={7} day={'Saturday'} hoursOfOperation={this.state.hoursOfOperation[this.state.modeSelected][6]} />
                        </div>
                    </div>
                    <div className='modifyHoursFooterContainer'>
                        <p className='modifyHoursInstructionsText'>Double click cell to edit minutes</p>
                        <button className='secondaryButton modifyHoursFooterButton' onMouseDown={this.props.displayModifyHours}>Cancel</button>
                        <button className='primaryButton modifyHoursFooterButton' onMouseDown={this.saveChangesHandler}>Save and Close</button>
                    </div>
                </motion.div>
            </motion.div>
        )
    }
}